import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import "./App.css";
import PublisherLogin from "./components/PublisherLogin";
import AdminLogin from "./components/AdminLogin";
import PublisherDashboard from "./components/PublisherDashboard";
import AdminDashboard from "./components/AdminDashboard";
import { Toaster } from "sonner";

const App = () => {
  const [publisherAuth, setPublisherAuth] = useState(null);
  const [adminAuth, setAdminAuth] = useState(null);

  // Check for existing auth on app load
  useEffect(() => {
    const savedPublisher = localStorage.getItem("publisher_auth");
    const savedAdmin = localStorage.getItem("admin_auth");
    
    if (savedPublisher) {
      try {
        setPublisherAuth(JSON.parse(savedPublisher));
      } catch (e) {
        localStorage.removeItem("publisher_auth");
      }
    }
    
    if (savedAdmin) {
      try {
        setAdminAuth(JSON.parse(savedAdmin));
      } catch (e) {
        localStorage.removeItem("admin_auth");
      }
    }
  }, []);

  const handlePublisherLogin = (publisherData) => {
    setPublisherAuth(publisherData);
    localStorage.setItem("publisher_auth", JSON.stringify(publisherData));
  };

  const handleAdminLogin = (adminData) => {
    setAdminAuth(adminData);
    localStorage.setItem("admin_auth", JSON.stringify(adminData));
  };

  const handlePublisherLogout = () => {
    setPublisherAuth(null);
    localStorage.removeItem("publisher_auth");
  };

  const handleAdminLogout = () => {
    setAdminAuth(null);
    localStorage.removeItem("admin_auth");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      <BrowserRouter>
        <Routes>
          <Route 
            path="/" 
            element={
              <div className="min-h-screen flex items-center justify-center p-6">
                <div className="max-w-md w-full space-y-8">
                  <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-900 mb-8">Kundportal</h1>
                  </div>
                  <div className="space-y-4">
                    <a 
                      href="/publisher-login"
                      className="w-full block bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-4 rounded-lg text-center transition-colors"
                      data-testid="publisher-login-link"
                    >
                      Logga in
                    </a>
                  </div>
                  
                  {/* Admin Login - Discreet and lower on page */}
                  <div className="mt-16 text-center">
                    <a 
                      href="/admin-login"
                      className="inline-block text-xs text-gray-400 hover:text-gray-600 font-normal py-1 px-3 rounded transition-colors"
                      data-testid="admin-login-link"
                    >
                      Admin
                    </a>
                  </div>
                </div>
              </div>
            } 
          />
          <Route 
            path="/publisher-login" 
            element={
              publisherAuth ? 
              <Navigate to="/publisher-dashboard" replace /> : 
              <PublisherLogin onLogin={handlePublisherLogin} />
            } 
          />
          <Route 
            path="/admin-login" 
            element={
              adminAuth ? 
              <Navigate to="/admin-dashboard" replace /> : 
              <AdminLogin onLogin={handleAdminLogin} />
            } 
          />
          <Route 
            path="/publisher-dashboard" 
            element={
              publisherAuth ? 
              <PublisherDashboard 
                publisher={publisherAuth} 
                onLogout={handlePublisherLogout} 
              /> : 
              <Navigate to="/publisher-login" replace />
            } 
          />
          <Route 
            path="/admin-dashboard" 
            element={
              adminAuth ? 
              <AdminDashboard 
                admin={adminAuth} 
                onLogout={handleAdminLogout} 
              /> : 
              <Navigate to="/admin-login" replace />
            } 
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default App;
